// extracted by mini-css-extract-plugin
export var closeButton = "_dw-1";
export var closeX = "_dw-3";
export var container = "_dw-0";
export var image = "_dw-2";